import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

const TIPO_REMOLQUE_CATALOGS = [
  {
    Value: "CTR001",
    Label: "Caballete",
  },
  {
    Value: "CTR002",
    Label: "Caja",
  },
  {
    Value: "CTR003",
    Label: "Caja Abierta",
  },
  {
    Value: "CTR004",
    Label: "Caja Cerrada",
  },
  {
    Value: "CTR005",
    Label: "Caja De Recolección Con Cargador Frontal",
  },
  {
    Value: 'CTR006',
    Label: 'Caja Refrigerada',
  },
  {
    Value: 'CTR007',
    Label: 'Caja Seca',
  },
  {
    Value: 'CTR008',
    Label: 'Caja Transferencia',
  },
  {
    Value: 'CTR009',
    Label: 'Cama Baja o Cuello Ganso',
  },
  {
    Value: 'CTR010',
    Label: 'Chasis Portacontenedor',
  },
  {
    Value: 'CTR011',
    Label: 'Convencional De Chasis',
  },
  {
    Value: 'CTR012',
    Label: 'Equipo Especial',
  },
  {
    Value: 'CTR013',
    Label: 'Estacas',
  },
  {
    Value: 'CTR014',
    Label: 'Góndola Madrina',
  },
  {
    Value: 'CTR015',
    Label: 'Grúa Industrial',
  },
  {
    Value: 'CTR016',
    Label: 'Grúa',
  },
  {
    Value: 'CTR017',
    Label: 'Integral',
  },
  {
    Value: 'CTR018',
    Label: 'Jaula',
  },
  {
    Value: 'CTR019',
    Label: 'Media Redila',
  },
  {
    Value: 'CTR020',
    Label: 'Pallet o Celdillas',
  },
  {
    Value: 'CTR021',
    Label: 'Plataforma',
  },
  {
    Value: 'CTR022',
    Label: 'Plataforma Con Grúa',
  },
  {
    Value: 'CTR023',
    Label: 'Plataforma Encortinada',
  },
  {
    Value: 'CTR024',
    Label: 'Redilas',
  },
  {
    Value: 'CTR025',
    Label: 'Refrigerador',
  },
  {
    Value: 'CTR026',
    Label: 'Revolvedora',
  },
  {
    Value: 'CTR027',
    Label: 'Semicaja',
  },
  {
    Value: 'CTR028',
    Label: 'Tanque',
  },
  {
    Value: 'CTR029',
    Label: 'Tolva',
  },
  {
    Value: 'CTR031',
    Label: 'Volteo',
  },
  {
    Value: 'CTR032',
    Label: 'Volteo Desmontable',
  },
];

class Remolque extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'remolque/one', saveUrl: 'remolque/save', backUrl: '/Catalogo/Remolques' },
      new Form([
        Form.Field('text', 'Placa', 'Placa', '', [Validators.required], 12, ),
        Form.Field('select', 'SubTipoRem', 'Tipo Remolque', '', [Validators.required], 12, TIPO_REMOLQUE_CATALOGS),
      ], ['Guardar'], 'Remolque'), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds();
    }
  }

  
  onSubmit = async (i, vals) => {
    let Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, FormData: Form.Reset(this.state.FormData) }, () => {
        if (this.props.back) {
          this.props.history.push(`${this.config.backUrl}`);
        }
        this.props.onSave(Res.data);
      });
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar: ${Res.errMsg}`, sbOpen: true });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Remolque)
